import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import CreditCardItem from "./CreditCardItem";
import EmptyStatus from "../../components/EmptyStatus";
import Loading from "../../components/Loading";
import Button from "../../components/Button";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import {GET_PAYMENT_METHODS, ON_BILLING_UPDATED} from "../../queries/customers";
import {requestAddCreditCard, requestAssignDefaultCreditCard, requestRemoveCreditCard} from "../../actions/AccountApiActions";
import {showContextualMenu} from "../../actions/ViewActions";

class CreditCardList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToUpdates(this.props, {}); 
  }

  render() {
    let {loading, error, billingPaymentMethods} = this.props.data;
    let tableHeader = List([
      "Card Id",
      "Brand",
      "Last 4",
      "Expires",
      "Added At",
      ""
    ])              
    let cards = fromJS(billingPaymentMethods);
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    if (cards.size === 0) {
      return <EmptyStatus status="No payment methods" />
    }
    return (
      <div>
        <Table 
          data={cards} 
          mode="table"
          renderer={CreditCardItem} 
          tableHeader={tableHeader}
          itemKey="paymentMethodId"
          onContextMenuClick={this.handleContextMenuClick.bind(this)}
          />
        <div className="buttons">
          <Button label="Add Card" onClick={this.handleAddCardClick.bind(this)} />
        </div>
      </div>
    )
  }

  handleAddCardClick() {
    this.props.requestAddCreditCard();
  }

  handleContextMenuClick(paymentMethodId, x, y) {
    this.props.showContextualMenu(
      [
        {label: "Make default", cmd: requestAssignDefaultCreditCard(this.props.accountId, paymentMethodId)},
        {label: "Remove", cmd: requestRemoveCreditCard(this.props.accountId, paymentMethodId)}
      ], 
      x, y);
  }
}

CreditCardList.defaultProps = {
  accountId: ""
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_BILLING_UPDATED,
      variables: {
        accountId: props.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  },
  requestAddCreditCard: () => {
    dispatch(requestAddCreditCard(ownProps.accountId))
  },
  showContextualMenu: (items, x, y) => {
    dispatch(showContextualMenu(items, x, y))
  }
})

const withQuery = compose(
  graphql(GET_PAYMENT_METHODS, {
    options: (props) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        accountId: props.accountId
      }    
    })
  })
);



export default connect(null, mapDispatchToProps)(withQuery(CreditCardList));